var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"orderInfoKeyValue",style:({'-webkit-line-clamp': _vm.maxLine})},[_c('span',{staticClass:"key"},[_vm._v(_vm._s(_vm.keyName))]),_c('span',{staticClass:"middle"},[_vm._v(": ")]),_c('span',{staticClass:"value",style:({color: _vm.valueColor})},[_vm._v(_vm._s(_vm.value))]),_c('div',{staticStyle:{"clear":"both"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }